import { type ShoppingCart } from "@/services/marketplace/cart/cartTypes";
import { type PaymentMethod } from "@/services/marketplace/paymentMethod";
import { type Ref } from "vue";

export function useIsPaymentMethodSelected(cart: Ref<ShoppingCart | undefined>, paymentMethod: PaymentMethod) {
  return computed(() => cart.value?.selectedPaymentMethod?.id === paymentMethod.id);
}
